/**
 * Find the nearest accessor of specified DOM element (including itself) which match a condition.
 * @param child The node whose accessor is to be found.
 * @param where The condition of the accessor you want to find.
 * @param until The condition of an accessor you want to stop the search.
 * @returns The accessor which match the condition, or `null` if not found.
 */
export function findAccessor(child, where, until) {
    function find(element) {
        if (element === null || until?.(element)) {
            return null;
        }
        if (where(element)) {
            return element;
        }
        return find(element.parentElement);
    }
    // Safari may trigger events on text nodes due to a bug.
    // We opt them out to avid `where` calls on non-element nodes.
    return find(child.nodeType === 1 /* Node.ELEMENT_NODE */
        ? child
        : child.parentElement);
}
